module.exports = __webpack_public_path__ + "static/subset-UniNeueBold-32b5c248c199f604db49440b6c8f512d.woff";